export const environment = {
  production: true,
  envName: 'prd',
  spa: {
    baseUrl: '/webapps',
    app: {
      cache: '/cache',
      res: '/reservation',
      srv: '/servicing',
      exc: '/exchange',
      cki: '/checkin',
    },
  },
  api: {
    baseUrl: 'https://space.ana.co.jp',
    clientId: 'e18203ea000c4d1f9906bafd70f043e0',
    clientSecret: '35049C70082948d4965417350a855858',
    app: {
      sysdate: '/all-sfj-sysdate/api/v1',
      authorization: '/all-sfj-authorization/api/v1',
      initialization: '/all-sfj-initialization/api/v1',
      user: '/all-sfj-user/api/v1',
      amcmember: '',
      search: '/all-sfj-search/api/v1',
      reservation: '/all-sfj-reservation/api/v1',
      servicing: '/all-sfj-servicing/api/v1',
      exchange: '/all-sfj-exchange/api/v1',
      checkin: '/all-sfj-checkin/api/v1',
      member: '/all-sfj-member/api/v1',
      credit: '/all-sfj-credit/api/v1',
    },
  },
  datadog: {
    disable: false,
    env: 'prd',
    clientToken: 'pub71ef99b3ce6dfa6584aae68f6452919e',
    versionFileRelativeUrl: '',
  },
  tealium: {
    disable: true,
    url: '',
  },
  dynatrace: {
    res: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/3208c71c40447a51_complete.js',
    },
    srv: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/ecb00109162978b7_complete.js',
    },
    exc: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/770a88895b70c842_complete.js',
    },
    cki: {
      disable: false,
      url: 'https://js-cdn.dynatrace.com/jstag/161f5a57e21/bf90419wvr/500e4fe1bd6fe74_complete.js',
    },
  },
};
